import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import styled from "@emotion/styled";

import AreaTypes from "types/AreaTypes";
import PointTypes from "types/PointTypes";
import PathTypes from "types/PathTypes";

import ParkkiTheme from "themes/ParkkiTheme";
import UnselectedChips from "components/UnselectedChips";

const Container = styled.div`
  padding-bottom: ${ParkkiTheme.spacings.xsmall};
`;

const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const SelectAllContainer = styled.div`
  margin-left: 4px;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

type Props = {
  label: string;
  layers: AreaTypes[] | PointTypes[] | PathTypes[];
  onSelectLayers: Function;
};

function UnselectedChipsSection({ label, layers, onSelectLayers }: Props) {
  const { formatMessage } = useIntl();

  const nbUnselectedLayers = useMemo(() => {
    // @ts-ignore
    return layers?.filter((layer) => !layer.selected)?.length || 0;
  }, [layers]);

  if (nbUnselectedLayers === 0) {
    return null;
  }

  function handleSelectAllLayers() {
    onSelectLayers(layers);
  }

  return (
    <Container>
      <LabelContainer>
        <div>{label}</div>

        <SelectAllContainer onClick={handleSelectAllLayers}>
          {formatMessage({
            id: `components.selectALayerInfo.selectAll`,
          })}
        </SelectAllContainer>
      </LabelContainer>

      <UnselectedChips layers={layers} onSelectLayers={onSelectLayers} />
    </Container>
  );
}

export default UnselectedChipsSection;
